import React from 'react';
import '../../../i18n';
import styled from 'styled-components';
import { withNamespaces,Trans } from 'react-i18next';
import {Default,Mobile} from '../../Sizes';
import HelpBox from '../../molecules/HelpBox';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import { 
	func, 
	string,
} from 'prop-types';

import {OkIcon,MenuDownIcon,MenuRightIcon,InfoIcon} from '../../atoms/Icons';

const style ={
	Discription : styled.ul`
        padding : 1rem;
    `,
	OkIcon : styled(OkIcon)`
		margin-right : 0.5rem;
	`,
	MenuDownIcon : styled(MenuDownIcon)`
		margin-right : 5px;
	`,
	MenuRightIcon : styled(MenuRightIcon)`
		margin-right : 5px;
	`,
	HelpBox,
	ConvertButton : styled(FloatingActionButton)`
		border-radius : 50%;
		width : 3rem;
		height : 3rem;
	`,
	InfoIcon : styled(InfoIcon)`
		margin-right : 0.5rem;
	`
};

function Help({ t,className,onClose }) {
	return (
		<style.HelpBox 
			onClose={onClose}
			className={className}
			term={<span><style.OkIcon/>{t('create-quiz-modal.Help')}</span>}
			description={<div>
				<style.Discription>
					<li>
						<Trans i18nKey="create-quiz-modal.HelpDescription"
							components={[
								<b key={0} >
                                test
								</b>
							]}
						>
						</Trans>
					</li>
					<li>
						<Default>
							<Trans i18nKey="create-quiz-modal.HelpDescription2"
								components={[
									<b key={0} >
                                test
									</b>
								]}
							>
							</Trans>
						</Default>
						<Mobile>
							{t('create-quiz-modal.HelpDescription2Mobile')}
						</Mobile>
					</li>
					<li>
						{t('create-quiz-modal.HelpDescription3')}
					</li>
				</style.Discription>
				<div>
					<style.InfoIcon/>
					<Trans i18nKey="create-quiz-modal.Hint"
						components={[
							<style.ConvertButton key={1}>
								test
							</style.ConvertButton>,
							<b key={1} >
                                test
							</b>
						]}
					>
					</Trans>
				</div>
			</div>}
		/>
	);
}

Help.propTypes = {
	t:func.isRequired,
	className:string,
	onClose : func.isRequired
};

export default withNamespaces()(Help);